import { render, staticRenderFns } from "./HistoryTrace.vue?vue&type=template&id=8afae4f0&scoped=true&"
import script from "./HistoryTrace.vue?vue&type=script&lang=js&"
export * from "./HistoryTrace.vue?vue&type=script&lang=js&"
import style0 from "./HistoryTrace.vue?vue&type=style&index=0&id=8afae4f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afae4f0",
  null
  
)

export default component.exports